import { Radio, RadioChangeEvent, Row } from "antd";
import { useCallback, useMemo } from "react";
import { IOption } from "../../../types/Option";
import { ITask } from "../types";

type HeaderProps = {
  setRequest: React.Dispatch<React.SetStateAction<any>>;
  setData: React.Dispatch<React.SetStateAction<ITask[]>>;
};

export const Header = ({ setRequest, setData }: HeaderProps) => {
  const options: IOption[] = useMemo(
    () => [
      {
        value: 0,
        label: "Open",
      },
      {
        value: 1,
        label: "Closed",
      },
    ],
    [],
  );

  const onChange = useCallback(
    (e: RadioChangeEvent) => {
      setData([]);
      const isClosed = e.target.value;

      const request: any = {
        pageNumber: 1,
        pageSize: 50,
        isClosed: isClosed === 1,
      };

      setRequest(request);
    },
    [setRequest, setData],
  );

  return (
    <Row className="d-block w-100 mx-8 header__container">
      <Row className="my-6">
        <h3 className="h h3">Tasks</h3>
      </Row>
      <Radio.Group
        optionType="button"
        options={options}
        defaultValue={0}
        onChange={onChange}
      />
    </Row>
  );
};
